import { Link } from "react-router-dom";

/* Swap the inner mark for the official AKLIVE SVG when supplied */
export const Logo = ({ onClick, className = "" }) => (
  <Link
    to="/"
    aria-label="AKLIVE"
    data-testid="header-logo-link"
    onClick={onClick}
    className={`inline-flex items-center ${className}`}
  >
    <img
      src="/aklive-logo.png"
      alt="AKLIVE"
      width="473"
      height="130"
      className="h-5 w-auto md:h-6"
    />
  </Link>
);
